import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { AILDataSave } from './ail-data-save';
import { IConfigState, IResultState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IAILDataSaveStateProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
  readonly result: IResultState;
}

export type IAILDataSaveConnectProps = IAILDataSaveStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IAILDataSaveStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    result: state.result
  };
}

export const AILDataSaveContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(AILDataSave);
